/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DIE DREI VARIANTEN DES BANDES. Neue Vorgabe des Betreibers vom
 * 24.09.2026 (`gemini-code-…html`, „Live-Vorschau der 3 Varianten"):
 * „Bitte den Newsletter Baustein nochmals umbauen. Es gibt nur diese
 * drei als Auswahl."
 * 
 *   STANDARD — Variante 1, ~125 px: Pille, Ueberschrift, Teasertext
 *              und Knopf untereinander.
 *   KOMPAKT  — Variante 2, ~100 px: wie Variante 1, OHNE die Pille.
 *   SLIM     — Variante 3, ~56 px: eine Zeile, Ueberschrift und Knopf
 *              nebeneinander.
 * 
 * Ohne Angabe gilt STANDARD.
 * 
 *   RASTER   — das Band fuellt seine Rasterzelle aus. NICHT MEHR
 *              WAEHLBAR seit 24.09.2026 („es gibt nur diese drei"), der
 *              Wert bleibt im Schema: Ein geloeschter Enum-Wert laesst
 *              jede Datenbank, die ihn noch traegt, nicht mehr laden.
 * @export
 */
export const DatabaseNewsletterHoehe = {
    Standard: 'STANDARD',
    Kompakt: 'KOMPAKT',
    Slim: 'SLIM',
    Raster: 'RASTER'
} as const;
export type DatabaseNewsletterHoehe = typeof DatabaseNewsletterHoehe[keyof typeof DatabaseNewsletterHoehe];


export function DatabaseNewsletterHoeheFromJSON(json: any): DatabaseNewsletterHoehe {
    return DatabaseNewsletterHoeheFromJSONTyped(json, false);
}

export function DatabaseNewsletterHoeheFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseNewsletterHoehe {
    return json as DatabaseNewsletterHoehe;
}

export function DatabaseNewsletterHoeheToJSON(value?: DatabaseNewsletterHoehe | null): any {
    return value as any;
}

